import { render } from "./WidgetInfoBox.vue?vue&type=template&id=4d101dc7&scoped=true"
import script from "./WidgetInfoBox.vue?vue&type=script&lang=js"
export * from "./WidgetInfoBox.vue?vue&type=script&lang=js"

import "../../modules/dashboard/css/adminlte.css?vue&type=style&index=0&id=4d101dc7&lang=css&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d101dc7"]])

export default __exports__